"use strict";

function ixUpgradeServiceImpl() {
    this.hasLoaded = function () {
        return true;
    };

    function isFunction(f) {
        return typeof f === "function";
    }

    this.isSupported = function () {
        return !!(
            ixUpgrade &&
            typeof ixUpgrade === "object" &&
            isFunction(ixUpgrade.getUpgradeConfigurations) &&
            isFunction(ixUpgrade.isStorageSupported) &&
            isFunction(ixUpgrade.setUpgradeConfigurationInStorage) &&
            ixUpgrade.isStorageSupported()
        );
    };

    this.getItems = function () {
        var path,
            workspace,
            idx,
            workspaceObj,
            result = [],
            workspaceResult = {},
            config;

        if (this.isSupported()) {
            config = ixUpgrade.getUpgradeConfigurations();

            for (idx = 0; idx < config.length; idx++) {
                path = config[idx].path;

                workspace = impactX.getWorkspaceByRoutePath(path);

                if (!workspace) {
                    workspace = impactX.getWorkspaceByRoutePath("/" + path);
                }

                if (!workspace) {
                    workspace = "unknown";
                }

                workspaceObj = workspaceResult[workspace];

                if (!workspaceObj) {
                    workspaceObj = {
                        label: workspace,
                        items: [],
                    };
                }

                var item = {
                    key: path,
                    label: path,
                    status: config[idx].uxStatus,
                    defaultStatus: config[idx].defaultStatus,
                };

                if (config[idx].desc && typeof config[idx].desc === "string") {
                    item.label = config[idx].desc;
                }

                workspaceObj.items.push(item);

                workspaceResult[workspace] = workspaceObj;
            }

            for (var wsName in workspaceResult) {
                result.push(workspaceResult[wsName]);
            }

            result.sort(function (a, b) {
                return a.label.localeCompare(b.label);
            });

            for (idx = 0; idx < result.length; idx++) {
                workspaceObj = result[idx];
                workspaceObj.items.sort(function (a, b) {
                    return a.label.localeCompare(b.label);
                });
            }

            return result;
        }
        return [];
    };

    this.saveItems = function (items) {
        var workspaceObj, wsIdx, pathIdx, pathObj, path, status;

        if (this.isSupported()) {
            var storageObj = {};
            for (wsIdx = 0; wsIdx < items.length; wsIdx++) {
                workspaceObj = items[wsIdx];

                for (
                    pathIdx = 0;
                    pathIdx < workspaceObj.items.length;
                    pathIdx++
                ) {
                    pathObj = workspaceObj.items[pathIdx];

                    path = pathObj.key;
                    status = pathObj.status;
                    if (path && typeof path === "string" && status) {
                        if (typeof status === "string") {
                            status = parseInt(status, 10);
                        }
                        storageObj[path] = status;
                    }
                }
            }

            ixUpgrade.setUpgradeConfigurationInStorage(storageObj);
        }
    };
}

ixModuleRouting("impactx.z", {
    "/upgrade": {
        templateUrl: "shared/z/templates/upgrade.html",
        controller: "ixUpgradeCtrl",
        controllerAs: "ctrl",
        //process: 'EditProfile' // Ggf. an eine Berechtigung binden ?
    },
})
.service("ixUpgradeService", ixUpgradeServiceImpl)
.service("AngularAllMigrationService", [
    "AngularModulesMigrationService",
    "AngularSharedMigrationService",
    "AngularRouterMigrationService",
    "ixUpgradeService",
    function (
        AngularModulesMigrationService,
        AngularSharedMigrationService,
        AngularRouterMigrationService,
        ixUpgradeService
    ) {
        ixTryRegisterService(
            "AngularRouterMigrationService",
            AngularRouterMigrationService
        );

        ixTryRegisterService("AngularAllMigrationService", this);

        this.hasLoadedServices = function (logCall) {
            if (logCall) {
                try {
                    console.log("All required services loaded.");
                }
                catch (e) {
                }
            }

            return (
                AngularModulesMigrationService.hasLoadedServices() &&
                AngularSharedMigrationService.hasLoadedServices() &&
                AngularRouterMigrationService.hasLoadedServices() &&
                ixUpgradeService.hasLoaded()
            );
        };
    },
])
.controller("ixUpgradeCtrl", [
    "$scope",
    "TranslationService",
    "ToastService",
    "ToolbarService",
    "ixUpgradeService",
    function ixUpgradeController(
        $scope,
        TranslationService,
        ToastService,
        ToolbarService,
        ixUpgradeService
    ) {
        var ctrl = this;

        $scope.labels = {
            oldMenuItem: "Old",
            newMenuItem: "New",
            bothMenuItems: "Both",
            //
            oldMainAction: "Old",
            newMainAction: "New",
            //
            oldAction: "Old",
            newAction: "New",
            bothActions: "Both",
        };

        $scope.isSupported = ixUpgradeService.isSupported();

        $scope.items = ixUpgradeService.getItems();

        ctrl.getTranslation = function (key) {
            return TranslationService.get(key);
        };

        ctrl.save = function () {
            ixUpgradeService.saveItems($scope.items);

            ToastService.openActionToast(
                "Saved locally in Local Storage. Please reload the page!",
                "Reload",
                function () {
                    location.reload();
                }
            );
        };

        ctrl.restore = function () {
            $scope.items = ixUpgradeService.getItems();
        };

        var buttonDefinition = [
            {
                label: "Save",
                action: function () {
                    ctrl.save();
                },
                type: "validation",
                condition: function () {
                    return ixUpgradeService.isSupported();
                },
            },
            {
                label: "Restore",
                action: function () {
                    ctrl.restore();
                },
                type: "validation",
                condition: function () {
                    return ixUpgradeService.isSupported();
                },
            },
        ];

        ToolbarService.setButtons(buttonDefinition);
    },
]);
